import {LqbPricerLogServiceName} from "../utils/names/serviceNames";
import {LqbPricerLogService} from "./service/LqbPricerLogService";
import {LqbPricerParametersServiceModule} from "./LqbPricerParametersServiceModuleConfiguration";

LqbPricerParametersServiceModule
    .createNewModule()
    .service(LqbPricerLogServiceName, LqbPricerLogService.instance);